import * as React from 'react'
import {
  PageInfoProvider,
  EnterpriseProvider,
  WorksheetProvider,
  CustomContextProvider,
  AnalyticsProvider,
  PraxisAuthContextBridge,
} from 'properties-ui-common'
import { AuthProvider, useAuth } from '@praxis/component-auth'
import { ToastAlertProvider } from '@design-systems/canvas-ui'
import { ToastProvider } from '@enterprise-ui/canvas-ui-react'
import { BrowserRouter } from 'react-router-dom'
import apiConfig from '../apiConfig'
import { Helmet } from 'react-helmet'
import { MainWrapper } from './core/MainWrapper'
import { worksheetReducer } from './core/MainWrapper/utilities/constants'
import { mfeNavUrls } from './MicroFrontEnds/utility/url'
import { mfeLabels } from './MicroFrontEnds/utility/labels'

const hostname = window && window.location && window.location.hostname

const CommonAuthContextBridge: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const auth = useAuth()

  return (
    <PraxisAuthContextBridge auth={auth}>{children}</PraxisAuthContextBridge>
  )
}

export const App = () => {
  // Check if the originating host contains partnersonline and take a different auth path
  if (hostname.includes('partnersonline')) {
    apiConfig.auth = {
      ...apiConfig.authPol,
    }
  }
  return (
    <>
      <Helmet>
        <title>{apiConfig.title}</title>
      </Helmet>
      <BrowserRouter>
        <AuthProvider {...apiConfig.auth}>
          <CommonAuthContextBridge>
            <AnalyticsProvider
              config={{
                //@ts-ignore
                appName: apiConfig.appName as string,
                apiKey: apiConfig.apiKey,
                url: apiConfig.analyticsUrl[
                  hostname.includes('partnersonline') ? 'external' : 'internal'
                ],
              }}
              trackClicks
            >
              <EnterpriseProvider env={apiConfig} withAuthProvider={false}>
                <PageInfoProvider mfeLabels={mfeLabels} mfeNavUrls={mfeNavUrls}>
                  <WorksheetProvider {...worksheetReducer}>
                    <CustomContextProvider>
                      <ToastAlertProvider location="top">
                        <ToastProvider location="top">
                          <MainWrapper />
                        </ToastProvider>
                      </ToastAlertProvider>
                    </CustomContextProvider>
                  </WorksheetProvider>
                </PageInfoProvider>
              </EnterpriseProvider>
            </AnalyticsProvider>
          </CommonAuthContextBridge>
        </AuthProvider>
      </BrowserRouter>
    </>
  )
}
